<template>
  <div
    class="hm-tab"
    :class="{
      'hm-tab--active': isActive,
    }"
    @click="onTabClick"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HMSwitchTab',
  props: {
    name: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    onTabClick() {
      this.$parent.selectTab(this.name);
    },
  },
  mounted() {
    this.isActive = this.$parent.selected === this.name;
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-tab {
  color: $dark-gray;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  padding: 0 0.75rem;
  &--active {
    background-color: var(--brand-color, $coral);
    color: white;
  }
}
</style>
